import { Moment } from 'moment';
import moment from 'moment/moment';

export interface AvailableBattleGroupDTO {
	id: string;
	name: string;
	locked: boolean;
	next_battle_starts_at: string | undefined | null;
}

export default class AvailableBattleGroup {
	private _id: string;
	private _name: string;
	private _locked: boolean;
	private _nextBattleStartsAt: Moment | null;

	constructor(battleGroup: AvailableBattleGroupDTO) {
		this._id = battleGroup.id;
		this._name = battleGroup.name;
		this._locked = battleGroup.locked;
		this._nextBattleStartsAt = !!battleGroup.next_battle_starts_at
			? moment(battleGroup.next_battle_starts_at)
			: null;
	}

	get id() {
		return this._id;
	}

	get name() {
		return this._name;
	}

	get locked() {
		return this._locked;
	}

	get nextBattleStartsAt() {
		return this._nextBattleStartsAt;
	}
}
